import { COLLEGES_API_URL } from '@constants/externalRoutes';
import { CollegeFavorite } from '@youscience/college-service-common';
import { AxiosResponse } from 'axios';
import api from '../utils/api';

const getCollegesSaved = async (): Promise<CollegeFavorite[]> => {
  const response: AxiosResponse<CollegeFavorite[]> = await api(`${COLLEGES_API_URL}/user/favorites/colleges`);

  return response?.data;
};

const unsaveFavoriteCollege = async (collegeId: string): Promise<CollegeFavorite> => {
  const response: AxiosResponse<CollegeFavorite> = await api(
    `${COLLEGES_API_URL}/user/favorites/colleges/${collegeId}`,
    { method: 'DELETE' },
  );

  return response?.data;
};

const CollegeService = { getCollegesSaved, unsaveFavoriteCollege };

export default CollegeService;
